import type { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AnalyticsProvider, CookieConsentRoot } from '@resida/analytics';

interface AppProps {
  helmetContext?: object;
  children: ReactNode;
}

function App({ helmetContext, children }: AppProps) {
  return (
    <AnalyticsProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY ?? ''}
      appName="web"
      enabled={import.meta.env.PROD}
    >
      <HelmetProvider context={helmetContext}>
        {children}
      </HelmetProvider>
      <CookieConsentRoot />
    </AnalyticsProvider>
  );
}

export default App;
